module.exports = __webpack_public_path__ + "img/icon-payment-scotia.7f8bae8c.png";